import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, extractError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = logged
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (_e) {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password, otpCode) => {
    const body = { email, password };
    if (otpCode) body.otp_code = otpCode;
    const { data } = await api.post("/auth/login", body);
    setUser(data);
    return data;
  };

  const register = async (email, password, name, role, phone_number = "", sms_opt_in = false, invite_token = "") => {
    const body = { email, password, name, role };
    if (phone_number) body.phone_number = phone_number;
    if (sms_opt_in) body.sms_opt_in = true;
    if (invite_token) body.invite_token = invite_token;
    const { data } = await api.post("/auth/register", body);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) { console.warn("[Auth] logout request failed (session cleared locally)", e); }
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refresh, extractError }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
